<script>
  import PostModalRenderer from '$lib/components/Modals/PostModalRenderer/PostModalRenderer.svelte';
  import HomepageTabs from '$pages/Tabs/HomepageTabs.svelte';
  import { postInModal } from '$src/stores';
  import { noNav } from '$src/stores/nav.store';

  noNav.set(false);
</script>

{#if $postInModal}
  <PostModalRenderer />
{/if}

<HomepageTabs />
